export const dealTime = (e :string|number) => {
  const year = new Date(e).getFullYear()
  const month = new Date(e).getMonth() + 1
  const date = new Date(e).getDate()
  const hour = new Date(e).getHours()
  const min = new Date(e).getMinutes()

  return year + '-' + String(month >= 10 ? month : ('0' + month)) + '-' + String(date >= 10 ? date : ('0' + date)) + 'T' + String(hour >= 10 ? hour : ('0' + hour)) + ':' + String(min >= 10 ? min : ('0' + min))
}
